import "./footer.scss";
import { FaHeart, FaRegCopyright } from "react-icons/fa";
import { motion } from "framer-motion";

const Footer = ({showSidebar}) => {
  const currentYear = new Date().getFullYear();

  return (
    <motion.footer
      className={`${showSidebar ? "footer_with_sidebar" : "footer"}`}
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <div className="footer-content">
        <p>
          <FaRegCopyright className="icon" />
          {currentYear} <span className="brand">plutos ONE</span>, India. All rights reserved  <span className="made-with"> Made with <FaHeart className="heart" /> by the plutos team.</span>
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;
